export default function hero() {
    let headerHeight = document.querySelector('.header').offsetHeight;
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    const heroSvg = document.querySelector('.hero__svg');

    heroSvg.addEventListener('click', function() {
        const targetSection = document.getElementById('product-slider');
        if (targetSection) {
            targetSection.scrollIntoView(
                { behavior: 'smooth' }
            );
        }
    });
}